'use client'

import { TypedLocale } from 'payload'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'

export const Error = ({ name, locale }: { name: string, locale: TypedLocale }) => {
  const {
    formState: { errors },
  } = useFormContext()
  return (
    <div className="mt-2 text-red-500 text-sm">
      {(errors[name]?.message as string) || (locale === 'de' ? 'Dieses Feld ist erforderlich' : 'This field is required')}
    </div>
  )
}
